// @flow
import { default as produce } from 'immer';

import * as actionTypes from './actions';
import type { Action } from './actions';
import { RESET_APP_STATE } from 'store/actionTypes';
import type { ISocial } from './ISocial';
import initialState from 'store/initialState';

const reducer = (
  state: ISocial = initialState.user.social,
  action: Action
): ISocial =>
  produce(
    state,
    (draft): ISocial | void => {
      if (action.type === actionTypes.PARTIAL_SIGN_IN) {
        draft.partialSignInProvider = action.payload;
      }
      if (action.type === RESET_APP_STATE) {
        return initialState.user.social;
      }
    }
  );

export default reducer;



// WEBPACK FOOTER //
// ./src/store/reducers/user/social/reducer.js